export default "__VITE_PUBLIC_ASSET__0e19a380__"